import { useMutation, useQueryClient, UseMutationResult, useQuery, UseQueryResult } from '@tanstack/react-query';
import { createBulkPartActions, createPartAction, deletePartActionById, getAllPartActionTypes, getPartActionByServiceId, updatePartActionById } from '../api/partAction';
import { PartActionKey, PartActionTypesKey } from '../configs/partAction';
import { PartActionResponse, PartActionTypes } from '../@types/partAction.type';
import { ServiceLogAllKey } from '../configs/services';

export const useAddPartAction = (id: number): UseMutationResult => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      return await createPartAction(data);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [PartActionKey, id]
      });
      await queryClient.invalidateQueries({
        queryKey: [ServiceLogAllKey, id]
      });
    }
  });
};

export const useGetPartActionByServiceId = (id: number): UseQueryResult<PartActionResponse[]> => {
  return useQuery({
    queryKey: [PartActionKey, id],
    queryFn: () => id !== 0 && getPartActionByServiceId(id),
    enabled: false
  });
};

export const useUpdatePartAction = (id: number): UseMutationResult => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      await updatePartActionById(data.id, data.data);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [PartActionKey, id]
      });
      await queryClient.invalidateQueries({
        queryKey: [ServiceLogAllKey, id]
      });
    }
  });
};

export const useDeletePartActionById = (id: number): UseMutationResult => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (data: any) => {
      return await deletePartActionById(data.id);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [PartActionKey, id]
      });
      await queryClient.invalidateQueries({
        queryKey: [ServiceLogAllKey, id]
      });
    }
  });
};

export const useGetPartActionTypes = (): UseQueryResult<PartActionTypes[]> => {
  return useQuery({
    queryKey: [PartActionTypesKey],
    queryFn: () => getAllPartActionTypes(),
    enabled: false
  });
};

export const useAddBulkPartActions = (serviceId: number): UseMutationResult => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      return await createBulkPartActions(serviceId, data);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ServiceLogAllKey, serviceId]
      });
    }
  });
};